import React from 'react';
import './SourceStatusBadge.css';

export type SourceStatusBadgeVariant = 'suggested' | 'unassigned' | 'neutral';

export interface SourceStatusBadgeProps {
  /** Colour variant: amber (suggested), red (unassigned), grey (neutral) */
  variant: SourceStatusBadgeVariant;
  /** Badge copy, supplied by the consumer (the atom carries no strings) */
  children: React.ReactNode;
  /** Optional custom className */
  className?: string;
}

/**
 * SourceStatusBadge - Pill showing the state of a tenant-config source row
 * (suggested / unassigned / neutral). Text comes from the consumer.
 */
export const SourceStatusBadge: React.FC<SourceStatusBadgeProps> = ({
  variant,
  children,
  className = '',
}) => (
  <span className={`source-status-badge source-status-badge--${variant} ${className}`.trim()}>
    {children}
  </span>
);

export default SourceStatusBadge;
